import type { FC } from "react";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

const AiAutomationProcess: FC = () => {
  const { t } = useTranslation();
  const steps = [
    {
      step: "01",
      title: t("ai_step_1_title"),
      desc: t("ai_step_1_desc"),
    },
    {
      step: "02",
      title: t("ai_step_2_title"),
      desc: t("ai_step_2_desc"),
    },
    {
      step: "03",
      title: t("ai_step_3_title"),
      desc: t("ai_step_3_desc"),
    },
    {
      step: "04",
      title: t("ai_step_4_title"),
      desc: t("ai_step_4_desc"),
    },
  ];

  return (
    <section className="bg-white py-10">
      <div className="max-w-7xl mx-auto px-5">

        {/* Header */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-6">
          <div>
            <p className="text-sm uppercase tracking-wider text-green-700 font-medium mb-3">
              {t("ai_title")}
            </p>
            <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900 max-w-xl leading-tight">
              {t("ai_subtitle")}
            </h2>
          </div>

          <p className="text-gray-600 max-w-sm">
            {t("ai_description")}
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-gray-200">
          {steps.map((item, index) => (
  <div
    key={index}
    className="group relative px-6 py-10 border-r border-gray-200 last:border-r-0 hover:bg-[#f6faf8] transition-all duration-300"
  >
    {/* Step Number */}
    <span className="
      absolute top-6 right-6 
      text-6xl font-bold 
      text-gray-200 
      group-hover:text-[#002F3F]
      transition-colors duration-300
    ">
      {item.step}
    </span>

    <h3 className="text-lg font-semibold text-gray-900 mb-3 relative z-10">
      {item.title}
    </h3>

    <p className="text-sm text-gray-600 leading-relaxed relative z-10">
      {item.desc}
    </p>

    {/* Arrow */}
    {index !== steps.length - 1 && (
      <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 bg-white rounded-full p-2 border border-gray-200">
        <ArrowRight size={16} className="text-gray-400" />
      </div>
    )}
  </div>
))}

        </div>

      </div>
    </section>
  );
};

export default AiAutomationProcess;
